<template>
  <th class="p-4">
    <slot />
  </th>
</template>